const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    enableRowGroup: true,
    cellStyle: {lineHeight: '20px'}
};

const initialState = {
    rowData: [],
    schemaNames: [],
    columnDefinitions: [],
    gridOptions: {
        defaultColDef,
        columnDefs: [],
        enableRangeSelection: true,
        animateRows: true,
        allowContextMenuWithControlKey: true,
        rowGroupPanelShow: 'always',
        
    },
    contextMenuItems: [],
};

export default initialState;
